module.exports = __webpack_public_path__ + "media/application/images/svgs/toggle-right-1e8305c5c6fc3f7d9f0c047b139dfb39.svg";